<template>
  <div class="ipo-detail-card">
    <div class="ipo-progress-header">
      <span class="ipo-detail-label">{{ $t('ipo.order_progress') }}</span>
      <span class="ipo-progress-pct">{{ pct }}%</span>
    </div>
    <div class="ipo-progress-track">
      <div class="ipo-progress-fill" :style="{ width: Math.min(pct, 100) + '%' }"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'IpoProgress',
  props: { symbol: { type: String, required: true } },
  computed: {
    ...mapGetters('ipoOrder', ['orderProgress']),
    pct() {
      const val = this.orderProgress[this.symbol]
      return val !== undefined ? parseFloat(val).toFixed(2) : 0
    },
  },
}
</script>
